export default __webpack_public_path__ + "static/media/sabathiP.91d667e0.jpg";